import axios from 'axios';

const adminApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

adminApi.interceptors.request.use((config) => {
  const key = sessionStorage.getItem('evapp_admin_key');
  if (key) config.headers['x-admin-key'] = key;
  return config;
});

export default adminApi;
